module.exports = __webpack_public_path__ + "assets/book.054facea.svg";